import { useBienContext } from '../BienContext'

import DetailTemplate from '@/components/DetailTemplate'
import { Textarea } from '@/components/ui'
import EditButtons from '../EditButtons'
import Form from './Form'

const Detail = () => {
  const { bien, wasUpdated, isPendingAction } = useBienContext()

  const SECTION_ID = "info_diverses"
  const SECTION_TITLE = "Informations diverses"

  const modalContent = <Form title={SECTION_TITLE} />
  
  const editButton = <EditButtons
    bienId={bien.id}
    isArchived={!!bien.archived_at}
    isPendingAction={isPendingAction}
    title="Modifier les informations diverses"
  />

  return(
    <DetailTemplate
      sectionId={SECTION_ID}
      title={SECTION_TITLE}
      bodyProps={{columns: 1}}
      wasUpdated={wasUpdated}
      loading={false}
      isPendingAction={isPendingAction}
      editButton={editButton}
      modalContent={modalContent}
    >
      <div className="space-y-4">
        <Textarea.Display value={bien.info_diverses} className='w-full' />
      </div>
    </DetailTemplate>
  )
}

export default Detail